import {
  ProductCategory,
  GroupType,
  ProductType,
} from '../type/productCategoryType';
import {
  ProductCategory as gqlProductCategory,
  GroupType as GQLGroupType,
  ProductType as GQLProductType,
} from 'graphql-query-contracts';

const groupTypeMap: Record<GQLGroupType, GroupType> = {
  [GQLGroupType.GroupTypeActivateChannel]: GroupType.ACTIVATE_CHANNEL,
  [GQLGroupType.GroupTypeActivateWhitelabel]: GroupType.ACTIVATE_WHITELABEL,
  [GQLGroupType.GroupTypeUnknown]: GroupType.UNKNOWN,
};

const productTypeMap: Record<GQLProductType, ProductType> = {
  [GQLProductType.ProductTypeCreditBundle]: ProductType.CREDIT_BUNDLE,
  [GQLProductType.ProductTypeServiceLabour]: ProductType.SERVICE_LABOUR,
  [GQLProductType.ProductTypeServiceMaterials]: ProductType.SERVICE_MATERIALS,
  [GQLProductType.ProductTypeUnknown]: ProductType.UNKNOWN,
};

export const mapGroupType = (groupType: GQLGroupType): GroupType => {
  return groupTypeMap[groupType] ?? GroupType.UNKNOWN;
};

export const mapProductType = (productType: GQLProductType): ProductType => {
  return productTypeMap[productType] ?? ProductType.UNKNOWN;
};

export function mapGqlProductCategoryToProductCategory(
  productCategory: gqlProductCategory
): ProductCategory {
  return {
    id: productCategory.productCategoryId,
    name: productCategory.name,
    description: productCategory.description,
    groupId: productCategory.groupId,
    productType: mapProductType(productCategory.productType),
    groupType: mapGroupType(productCategory.groupType),
  };
}